import React from 'react';
import { Link } from 'react-router-dom';
import Title from 'antd/lib/typography/Title';
import './ClientError.css';
import routeLocations from '../../utility/route-locations';


/**
 * The error that is displayed when something has gone wrong with the client.
 */
export default function ClientError() {
  return (
    <div className="not-found-wrapper">
      <div className="client-error-summary">
        <Title level={1} className="client-error-title">An unrecoverable error has occurred.</Title>
      </div>
      <Link className="inverse-link client-error-link" to={routeLocations.dashboard}>Back to the dashboard</Link>
    </div>
  );
}
